import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AllfilesComponent } from './pages/allfiles/allfiles.component';
import { VoiceAnnotationsComponent } from './pages/voice-annotations/voice-annotations.component';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
  {
    path: '', redirectTo: "login", pathMatch: "full"
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path:'allfiles', component:AllfilesComponent,
    canActivate: [MsalGuard]
  },
  {
    path:"VoiceAnnotations", component:VoiceAnnotationsComponent,canActivate:[MsalGuard]

  },
  {
    path: 'AudioTranslation', loadChildren: () => import('../app/layout/home/home.module').then((m) => m.homeModule),
    canActivate:[MsalGuard]
  },
  {
    path: '**', component: LoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
